import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './context/CartContext';
import { PromoTicker } from './components/PromoTicker';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { Science } from './pages/Science';
import { ScienceArticle } from './pages/ScienceArticle';
import { FacebookPixel } from './components/FacebookPixel';
import { RecoveryChatbot } from './components/RecoveryChatbot';
import './App.css';

function AppContent() {
  return (
    <div className="App min-h-screen premium-app-shell text-zinc-100 flex flex-col">
      <PromoTicker />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/science" element={<Science />} />
          <Route path="/science/:slug" element={<ScienceArticle />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" toastOptions={{ style: { background: '#18181b', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' } }} />
      <RecoveryChatbot />
    </div>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <FacebookPixel />
        <AppContent />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
